var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scheduled-loads", {
    attrs: {
      loads: _vm.inTransitLoads,
      company: _vm.company,
      status: _vm.loadStatus.IN_TRANSIT
    },
    on: {
      refresh: function($event) {
        return _vm.$emit("refresh")
      },
      updateLoad: function($event) {
        return _vm.$emit("updateLoad", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b56497", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b56497","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Receiving/InTransit.vue
// module id = null
// module chunks = 